// Escape any regex metacharacters in a literal string so it can be
// safely interpolated into `new RegExp(...)`. SECURITY_AUDIT M-9 —
// fake-ID substitution in chat messages used `new RegExp(`\\b${fakeId}\\b`)`
// directly; if a fakeId ever contained `.`, `(`, `*`, etc., the regex
// would behave unexpectedly (silent miss, runaway backtracking).
export function escapeRegExp(s) {
  return String(s == null ? '' : s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export default escapeRegExp;
